import { render, staticRenderFns } from "./InstallPWADesktopWizard.vue?vue&type=template&id=67e8bb76"
import script from "./InstallPWADesktopWizard.vue?vue&type=script&lang=ts"
export * from "./InstallPWADesktopWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports